import * as React from "react";
import { Input } from "./ui/input";
import { Textarea } from "./ui/textarea";

export interface FieldProps {
  /** Render an input or a textarea. @default "input" */
  as?: "input" | "textarea";
  label?: React.ReactNode;
  /** Helper text under the control. */
  hint?: React.ReactNode;
  value?: string;
  onChange?: (value: string) => void;
  placeholder?: string;
  /** Textarea rows. @default 4 */
  rows?: number;
  /** input type. @default "text" */
  type?: string;
  /** Caps input length at the source, matching the contract the write path enforces. */
  maxLength?: number;
  disabled?: boolean;
  style?: React.CSSProperties;
}

export function Field({as = "input", label, hint, value, onChange, placeholder, rows = 4,
  type = "text", maxLength, disabled = false, style}: FieldProps) {
  const id = React.useId();
  const hintId = hint ? `${id}-hint` : undefined;
  return <div data-slot="field" data-disabled={disabled || undefined} className="block font-sans" style={style}>
    {label && <label htmlFor={id} className="mb-1.5 block text-[length:var(--text-label)] font-bold text-[var(--text-secondary)]">{label}</label>}
    {as === "textarea"
      ? <Textarea id={id} aria-describedby={hintId} value={value} onChange={e => onChange?.(e.target.value)} placeholder={placeholder} rows={rows} maxLength={maxLength} disabled={disabled} />
      : <Input id={id} aria-describedby={hintId} type={type} maxLength={maxLength} value={value} onChange={e => onChange?.(e.target.value)} placeholder={placeholder} disabled={disabled} />}
    {hint && <div id={hintId} className="mt-1.5 text-[length:var(--text-body-sm)] text-muted-foreground">{hint}</div>}
  </div>;
}
